import React, { Component } from 'react'
import { Card, DialogContainer, TabsContainer, Tabs, Tab } from 'react-md'
import { withRouter } from 'react-router-dom'

import * as routes from 'routes'

import Heading from '../Heading'
import SignIn from '../SignIn'
import SignUp from '../SignUp'

import logo from './images/logo.png'

import './index.css'

const TABS = {
  SIGNIN: 0,
  SIGNUP: 1
}

class Main extends Component {
  constructor (props) {
    super(props)

    this.state = {
      activeTab: null
    }

    this.handleHashCode = this.handleHashCode.bind(this)
    this.onTabClick = this.onTabClick.bind(this)
    this.goToSignIn = this.goToSignIn.bind(this)
  }

  componentWillMount () {
    const { location } = this.props
    this.handleHashCode(location.hash)
  }

  componentWillReceiveProps (nextProps) {
    const { location } = nextProps
    if (location.hash !== this.props.location.hash) {
      this.handleHashCode(location.hash)
    }
  }

  goToSignIn () {
    const { history } = this.props
    history.push(routes.signIn())
  }

  handleHashCode (hash) {
    switch (hash) {
      case '#signin':
        return this.setState({ activeTab: TABS.SIGNIN })
      case '#forgot-password':
        return this.setState({ activeTab: TABS.SIGNIN })
      case '#verify-email':
        return this.setState({ activeTab: TABS.SIGNIN })
      case '#email-verified':
        return this.setState({ activeTab: TABS.SIGNIN })
      case '#signup':
        return this.setState({ activeTab: TABS.SIGNUP })
      default:
        return this.setState({ activeTab: TABS.SIGNUP })
    }
  }

  onTabClick (index, id) {
    const { history } = this.props
    const f = id === 'signin' ? routes.signIn : routes.signUp
    history.push(f())
  }

  render () {
    const {
      location,
      onSignIn,
      onSignUp,
      recaptchaSignInRef,
      recaptchaSignUpRef
    } = this.props
    const { activeTab } = this.state

    return (
      <div className='home-container'>
        <Card className='main-signup'>

          <div className='home-header'>
            <img src={logo} width='144' className='home-logo' alt='logo' />
            <Heading />
          </div>

          <DialogContainer
            id='help-message-dialog'
            visible={location.hash === '#verify-email'}
            onHide={this.goToSignIn}
            title='Confirm Email'
            actions={[{
              onClick: this.goToSignIn,
              primary: true,
              label: 'Close'
            }]}
            focusOnMount={false}
            portal
            width={600}
          >
            <p>
              Thanks for signing up. Before you get started, please confirm
              your email by clicking the verification link we just sent to your
              inbox. This helps us keep the platform free from spammers and
              fraudsters.
            </p>
          </DialogContainer>

          <DialogContainer
            id='help-message-dialog'
            visible={location.hash === '#email-verified'}
            onHide={this.goToSignIn}
            title='Email Verified'
            actions={[{
              onClick: this.goToSignIn,
              primary: true,
              label: 'Sign In'
            }]}
            focusOnMount={false}
            portal
            width={500}
          >
            <p>Your email has been confirmed!</p>
          </DialogContainer>

          <TabsContainer
            activeTabIndex={activeTab}
            onTabChange={this.onTabClick}
          >
            <Tabs tabId='home' centered>

              <Tab id='signin' label='Login'>
                { activeTab === 0 && (
                  <SignIn
                    onSubmit={onSignIn}
                    recaptchaRef={recaptchaSignInRef}
                  />
                ) }
              </Tab>

              <Tab id='signup' label='Sign up'>
                { activeTab === 1 && (
                  <SignUp
                    onSubmit={onSignUp}
                    recaptchaRef={recaptchaSignUpRef}
                  />
                ) }
              </Tab>

            </Tabs>
          </TabsContainer>

        </Card>
      </div>
    )
  }
}

export default withRouter(Main)



// WEBPACK FOOTER //
// ./src/containers/Home/Main/index.js